<div class="flex flex-direction-column justify-center align-items center add-margin container">
  <h1>404</h1>
  <h2>{{'page-not-found-title' | translate}}</h2>
</div>

